export const BBPS_DASHBOARD_TABS = {
  ORDERS: 'orders',
  COMPLAINTS: 'complaints',
  CATEGORIES: 'categories'
};

export const BBPS_DASHBOARD_TAB_LABELS = {
  [BBPS_DASHBOARD_TABS.ORDERS]: 'Orders',
  [BBPS_DASHBOARD_TABS.COMPLAINTS]: 'Complaints',
  [BBPS_DASHBOARD_TABS.CATEGORIES]: 'Categories'
};

export const BBPS_DASHBOARD_STRINGS = {
  TITLE: 'BBPS Dashboard',
  ORDERS_TAB_TITLE: 'BBPS Orders Management',
  ORDERS_TAB_DESCRIPTION: 'Search and manage BBPS orders with advanced filtering and pagination.'
};
